/**
 * Shared validation for component field names (the `name` property that becomes
 * a `${form.x}` key in the Flow JSON).
 *
 * WhatsApp reserves a handful of top-level namespaces; a field named after one
 * of them makes every `${...}` reference to it ambiguous and Meta rejects the
 * flow. Documented in `front-end/docs/whatsapp-flow-components-structure.md`
 * (§Component Validation Rules), this is the implementation of that rule.
 *
 * Kept as one helper rather than eleven copies so the plugins cannot drift.
 */

export const RESERVED_FIELD_NAMES = ['data', 'form', 'global', 'screen'];

/**
 * Returns the reserved-word errors for a field name (empty when fine).
 * The "required" and identifier-shape checks stay in each plugin, their
 * wording differs per component and is asserted by existing tests.
 *
 * @param {string} name
 * @returns {string[]}
 */
export const reservedFieldNameErrors = (name) => {
  if (typeof name !== 'string') {
    return [];
  }
  if (!RESERVED_FIELD_NAMES.includes(name.trim())) {
    return [];
  }
  return [
    `Field name cannot be a reserved word (${RESERVED_FIELD_NAMES.join(', ')})`,
  ];
};
